/*

? First, let's import the interface that will describe the shape of our subscriptions object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the subscriptions object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const test_client_crm_integration_webhooks: StateInterface["test_client_crm_integration_webhooks"] = {
  statusCode: "",
  status: "",
};